import { createReducer, on } from '@ngrx/store';
import { partnerClientActions } from '../actions/partner-client.actions';
import { IPartnerClient, IPartnerClientWithSecret } from '../models/outbound/partner-client.model';

export interface PartnerClientState {
    clients: IPartnerClient[];
    loading: boolean;
    /** Create/rotate/revoke in flight — modals disable their actions on it. */
    mutating: boolean;
    error: string | null;
}

const initialState: PartnerClientState = {
    clients: [],
    loading: false,
    mutating: false,
    error: null,
};

/** The one-time secret stays with the modal (actions stream) — never in the store. */
function withoutSecret(client: IPartnerClientWithSecret): IPartnerClient {
    const { clientSecret: _clientSecret, ...rest } = client;
    return rest;
}

export const partnerClientReducer = createReducer(
    initialState,
    on(partnerClientActions.loadClients, (state) => ({ ...state, loading: true, error: null })),
    on(partnerClientActions.loadClientsSuccess, (state, { clients }) => ({ ...state, clients, loading: false })),
    on(partnerClientActions.loadClientsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    on(partnerClientActions.createClient, partnerClientActions.rotateSecret, partnerClientActions.revokeClient, (state) => ({
        ...state,
        mutating: true,
        error: null,
    })),
    on(partnerClientActions.createClientSuccess, (state, { client }) => ({
        ...state,
        mutating: false,
        clients: [withoutSecret(client), ...state.clients],
    })),
    on(partnerClientActions.rotateSecretSuccess, (state, { client }) => ({
        ...state,
        mutating: false,
        clients: state.clients.map((existing) => (existing.id === client.id ? withoutSecret(client) : existing)),
    })),
    on(partnerClientActions.revokeClientSuccess, (state, { id }) => ({
        ...state,
        mutating: false,
        clients: state.clients.map((existing) =>
            existing.id === id ? { ...existing, status: 'revoked' as const } : existing,
        ),
    })),
    on(
        partnerClientActions.createClientFailure,
        partnerClientActions.rotateSecretFailure,
        partnerClientActions.revokeClientFailure,
        (state, { error }) => ({ ...state, mutating: false, error }),
    ),
);
